import React from 'react';

export default function HighlightCard({ icon, title, text }) {
  return (
    <div style={styles.card}>
      <div style={styles.iconWrapper}>
        <span style={styles.icon}>{icon}</span>
      </div>
      <h3 style={styles.title}>{title}</h3>
      <p style={styles.text}>{text}</p>
    </div>
  );
}

const styles = {
  card: {
    backgroundColor: 'white',
    borderRadius: '18px',
    padding: '2rem 1.6rem',
    textAlign: 'center',
    boxShadow: '0 4px 20px rgba(45,106,79,0.1)',
    flex: '1 1 220px',
    border: '1px solid rgba(64,145,108,0.1)',
    transition: 'transform 0.25s, box-shadow 0.25s',
  },
  iconWrapper: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '64px',
    height: '64px',
    borderRadius: '16px',
    backgroundColor: '#d8f3dc',
    marginBottom: '1.1rem',
  },
  icon: { fontSize: '2rem', lineHeight: 1 },
  title: {
    color: '#1b4332',
    fontFamily: "'Nunito', Arial, sans-serif",
    fontSize: '1.1rem',
    fontWeight: '800',
    marginBottom: '0.5rem',
  },
  text: {
    color: '#4a6558',
    fontFamily: "'Nunito', Arial, sans-serif",
    fontSize: '0.95rem',
    lineHeight: '1.65',
  },
};
